import React from "react";
import { Container } from "react-bootstrap";
import "./pageLayout.css";

const PageLayout = ({
  title,
  headerActions,
  children,
  className = "",
  titleIcon,
  stickyHeader = false,
  headerRef,
  customHeader = null,
  banner = null,
}) => {
  // If customHeader is provided, use it instead of the default header
  if (customHeader) {
    return (
      <Container fluid className={`page-layout-container ${className}`}>
        {customHeader}
        {banner}
        <div className="page-content">{children}</div>
      </Container>
    );
  }

  return (
    <Container fluid className={`page-layout-container ${className}`}>
      {/* Header */}
      <div
        ref={headerRef}
        className={`page-layout-header ${stickyHeader ? "sticky" : ""}`}
      >
        <div className="header-title">
          <h2>{title}</h2>
          {titleIcon}
        </div>
        {headerActions && <div className="header-actions">{headerActions}</div>}
      </div>

      {/* Optional Banner */}
      {banner}

      {/* Content */}
      <div className="page-content">{children}</div>
    </Container>
  );
};

export default PageLayout;
